import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import {
      FormControl,
      InputLabel,
      Select,
      MenuItem,
      Checkbox,
      ListItemText,
} from "@material-ui/core";

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})

class ChangeEmployee extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  roles: [],
                  selectedRoles: [],
                  agentPermision: [],
                  rowsPerPage: 10,
                  page: 0,
                  rowsPerPage2: 5,
                  page2: 0,
                  employee_id: "",
                  employee_name: "",
                  employee_family: "",
                  employee_mobile: "",
                  employee_deactive: "1",
                  employee_image: "",
                  orderBy: "employee_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newEmployee: true,
            }
      }

      handleChangeName = (event) => {
            this.setState({ employee_name: event.target.value })
      }

      handleChangeFamily = (event) => {
            this.setState({ employee_family: event.target.value })
      }

      handleChangeMobile = (event) => {
            this.setState({ employee_mobile: event })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ employee_deactive: "0" })
            } else {
                  this.setState({ employee_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        employee_id: row2.employee_id,
                        employee_name: row2.employee_name,
                        employee_family: row2.employee_family,
                        employee_mobile: row2.employee_mobile,
                        employee_deactive: row2.employee_deactive,
                        employee_image: row2.employee_image,
                        selectedRoles: row2.roles ? row2.roles.map((r) => r.role_id) : [], // 👈 نقش‌ها
                        newEmployee: false,
                  },
                  () => {
                        this.getPermisionEmployee()
                  }
            )
      }

      newEmployee = (event) => {
            this.setState({
                  employee_id: "",
                  employee_name: "",
                  employee_family: "",
                  employee_mobile: "",
                  employee_deactive: "0",
                  employee_image: "",
                  newEmployee: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getEmployee()
                                    self.getEmployeeRoles()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getEmployee() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getEmployeeRoles() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ roles: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee_roles")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPermisionEmployee() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var i,
                                    j,
                                    temp,
                                    temparray = []
                              for (i = 0; i < arr.data1.length; i++) {
                                    temp = {
                                          entity_desc: arr.data1[i].permision_entity_desc,
                                          entity_name: arr.data1[i].permision_entity_name,
                                          new: false,
                                          view: false,
                                          modify: false,
                                          delete: false,
                                    }
                                    temparray.push(temp)
                              }
                              console.log(temparray)
                              var exist

                              for (j = 0; j < temparray.length; j++) {
                                    exist = 0
                                    for (i = 0; i < arr.data.length; i++) {
                                          if (arr.data[i].emloyee_permision_entity === temparray[j].entity_name) {
                                                if (arr.data[i].emloyee_permision_mode === "new") {
                                                      temparray[j].new = true
                                                      exist = 1
                                                } else if (arr.data[i].emloyee_permision_mode === "modify") {
                                                      temparray[j].modify = true
                                                      exist = 1
                                                } else if (arr.data[i].emloyee_permision_mode === "view") {
                                                      temparray[j].view = true
                                                      exist = 1
                                                } else if (arr.data[i].emloyee_permision_mode === "delete") {
                                                      temparray[j].delete = true
                                                      exist = 1
                                                }
                                          }
                                    }
                                    //temparray.splice(j, 1);
                              }

                              self.setState(
                                    {
                                          agentPermision: temparray,
                                    },
                                    () => {}
                              )
                        } else if (arr.result === "error") {
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee_permission")
            fd.append("filter1", "emloyee_permision_emloyee_id=" + this.state.employee_id)

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewEmployee = () => {
            const { employee_name, employee_family, employee_mobile, employee_deactive, selectedRoles } = this.state

            if (
                employee_name !== "" &&
                employee_family !== "" &&
                employee_mobile !== "" &&
                employee_deactive !== "" &&
                selectedRoles.length > 0
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getEmployee()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_employee")
                  fd.append("employee_name", employee_name)
                  fd.append("employee_family", employee_family)
                  fd.append("employee_mobile", employee_mobile)
                  fd.append("employee_deactive", employee_deactive)
                  fd.append("roles", JSON.stringify(selectedRoles)) // 👈 این خط مهمه!

                  xhttp.open("POST", `${constants.BASE_URL}/employee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات کارمند را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeEmployee = () => {
            const { employee_id, employee_name, employee_family, employee_mobile, employee_deactive , selectedRoles } = this.state
            if (
                employee_name !== "" &&
                employee_family !== "" &&
                employee_mobile !== "" &&
                employee_deactive !== "" &&
                selectedRoles.length > 0
            ) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getEmployee()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_employee")
                  fd.append("employee_id", employee_id)
                  fd.append("employee_name", employee_name)
                  fd.append("employee_family", employee_family)
                  fd.append("employee_mobile", employee_mobile)
                  fd.append("employee_deactive", employee_deactive)
                  fd.append("roles", JSON.stringify(selectedRoles)) // 👈 این خط مهمه!


                  xhttp.open("POST", `${constants.BASE_URL}/employee`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangeRowsPerPage2 = (event) => {
            this.setState({ rowsPerPage2: parseInt(event.target.value), page2: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      handleChangePage2 = (event, number) => {
            this.setState({ page2: parseInt(number, 0) })
      }

      render() {
            const { classes } = this.props
            const {
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newEmployee,
                  employee_id,
                  employee_name,
                  employee_family,
                  employee_image,
                  employee_mobile,
                  employee_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                  rowsPerPage2,
                  page2,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره کارمند: " + employee_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <Avatar alt="Remy Sharp" className={classes.large} src={employee_image} />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام"
                                                                        handleInputt={this.handleChangeName}
                                                                        value={employee_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام خانوادگی"
                                                                        handleInputt={this.handleChangeFamily}
                                                                        value={employee_family}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="شماره همراه "
                                                                        handleInputt={this.handleChangeMobile}
                                                                        value={employee_mobile}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FormControl fullWidth>
                                                                        <InputLabel id="roles-select-label">نقش‌ها</InputLabel>
                                                                        <Select
                                                                            labelId="roles-select-label"
                                                                            multiple
                                                                            value={this.state.selectedRoles}
                                                                            onChange={(e) => this.setState({ selectedRoles: e.target.value })}
                                                                            renderValue={(selected) =>
                                                                                this.state.roles
                                                                                    .filter((r) => selected.includes(r.role_id))
                                                                                    .map((r) => r.role_name)
                                                                                    .join(", ")
                                                                            }
                                                                        >
                                                                              {this.state.roles.map((role) => (
                                                                                  <MenuItem key={role.role_id} value={role.role_id}>
                                                                                        <ListItemText primary={role.role_name} />
                                                                                        <Checkbox checked={this.state.selectedRoles.indexOf(role.role_id) > -1} />
                                                                                  </MenuItem>
                                                                              ))}
                                                                        </Select>
                                                                  </FormControl>
                                                            </Grid>


                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={employee_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت کارمند"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newEmployee ? (
                                                                        <Button variant="outlined" color="primary" onClick={this.saveNewEmployee}>
                                                                              {"ثبت کارمند جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newEmployee}>
                                                                                    {"کارمند جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changeEmployee}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>

                                                            {newEmployee ? null : (
                                                                  <Grid item xs={12}>
                                                                        <TableContainer component={Paper}>
                                                                              <Table className={classes.table} aria-label="simple table">
                                                                                    <TableHead>
                                                                                          <TableRow>
                                                                                                <TableCell style={{ minWidth: 80 }} align="center">
                                                                                                      عملیات{" "}
                                                                                                </TableCell>
                                                                                                <TableCell style={{ minWidth: 30 }} align="center">
                                                                                                      نمایش
                                                                                                </TableCell>
                                                                                                <TableCell style={{ minWidth: 30 }} align="center">
                                                                                                      تغییر{" "}
                                                                                                </TableCell>
                                                                                                <TableCell style={{ minWidth: 30 }} align="center">
                                                                                                      {" "}
                                                                                                      جدید{" "}
                                                                                                </TableCell>
                                                                                                <TableCell style={{ minWidth: 30 }} align="center">
                                                                                                      حذف{" "}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    </TableHead>
                                                                                    <TableBody>
                                                                                          {agentPermision
                                                                                                .slice(
                                                                                                      page2 * rowsPerPage2,
                                                                                                      page2 * rowsPerPage2 + rowsPerPage2
                                                                                                )
                                                                                                .map((row) => {
                                                                                                      return (
                                                                                                            <TableRow key={row.image_name}>
                                                                                                                  <TableCell align="center">
                                                                                                                        {" "}
                                                                                                                        {row.entity_desc}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.view ? (
                                                                                                                              <CheckIcon color="#00ff00" />
                                                                                                                        ) : (
                                                                                                                              <CloseIcon color="error" />
                                                                                                                        )}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.modify ? (
                                                                                                                              <CheckIcon color="#00ff00" />
                                                                                                                        ) : (
                                                                                                                              <CloseIcon color="error" />
                                                                                                                        )}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.new ? (
                                                                                                                              <CheckIcon color="#00ff00" />
                                                                                                                        ) : (
                                                                                                                              <CloseIcon color="error" />
                                                                                                                        )}
                                                                                                                  </TableCell>
                                                                                                                  <TableCell align="center">
                                                                                                                        {row.delete ? (
                                                                                                                              <CheckIcon color="#00ff00" />
                                                                                                                        ) : (
                                                                                                                              <CloseIcon color="error" />
                                                                                                                        )}
                                                                                                                  </TableCell>
                                                                                                            </TableRow>
                                                                                                      )
                                                                                                })}
                                                                                    </TableBody>
                                                                              </Table>
                                                                        </TableContainer>
                                                                        <TablePagination
                                                                              rowsPerPageOptions={[5, 10, 25, 100]}
                                                                              component="div"
                                                                              count={agentPermision.length}
                                                                              rowsPerPage={rowsPerPage2}
                                                                              page={page2}
                                                                              onChangePage={this.handleChangePage2}
                                                                              onChangeRowsPerPage={this.handleChangeRowsPerPage2}
                                                                        />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>
                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"employee_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "employee_id" ? order : false}
                                                                              >
                                                                                    {" آی دی کارمند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "employee_id"}
                                                                                          direction={orderBy === "employee_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("employee_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"employee_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نام و نام خانوادگی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "employee_name"}
                                                                                          direction={orderBy === "employee_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("employee_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"employee_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره همراه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "employee_mobile"}
                                                                                          direction={orderBy === "employee_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("employee_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"employee_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت کارمند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "employee_deactive"}
                                                                                          direction={orderBy === "employee_deactive" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("employee_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["employee_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <Avatar
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["employee_image"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"employee_id"} align={"center"}>
                                                                                                      {row["employee_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"employee_name"} align={"center"}>
                                                                                                      {row["employee_name"] +
                                                                                                            " " +
                                                                                                            row["employee_family"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"employee_mobile"} align={"center"}>
                                                                                                      {row["employee_mobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"employee_deactive"} align={"center"}>
                                                                                                      {row["employee_deactive"] === "1" ||
                                                                                                      row["employee_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeEmployee)
